import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { responsedata, themeData } from 'src/interface/themesetting';
import { EnvService } from './env.service';
import { Subject } from 'rxjs';
import { faqResponse } from 'src/interface/faq';
import { journalPageResponce } from 'src/interface/contentGet';

@Injectable({
    providedIn: 'root'
})
export class MainBodyService {
    themeData: themeData;
    public secondNavigation = new Subject<boolean>();
    secondNavigationBar$ = this.secondNavigation.asObservable();
    public secondNavigationBook = new Subject<boolean>();
    secondNavigationBarBook$ = this.secondNavigationBook.asObservable();

    constructor(private http: HttpClient, private EnvService: EnvService) { }
    getAllThemeSettings(journal_id: string) {
        const param = {
            journal_id: journal_id
        };

        return this.http.get<responsedata>(this.EnvService.siteApiUrl + "web/gettheme_logobanner?journal_id=" + param.journal_id);
    }
    getAllDynamicMenus(param:string) {
        return this.http.get<journalPageResponce>(this.EnvService.siteApiUrl + "web/getDynamicMenus?journal_id=" + param);
    }
    getAllFaq() {
        return this.http.get<faqResponse>(this.EnvService.siteApiUrl + "web/getAllFAQs");
    }
    getAlljournals() {
        return this.http.get<responsedata>(this.EnvService.siteApiUrl + "web/getAllJournals");
    }
    urlchange(data: boolean) {
        this.secondNavigation.next(data);
    }
    urlchange_book(data: boolean) {
        this.secondNavigationBook.next(data);
    }
}
